export default "__VITE_ASSET__CEsL$rzw__"